// Void print toggles from the Void modal, persisted on this terminal. Shared so
// that voids arriving from the mobile app print the same way as the cashier's
// own last choice in the modal.
//  - kitchen: one key for the terminal, default ON (legacy behaviour).
//  - cashier copy: per customer — staff sign in to several shops on one terminal
//    and each shop sets it on its own. Default OFF.

const KITCHEN_KEY = 'niceloop.void.printKitchen'
const cashierKey = () => `niceloop.void.copyToCashier:${useAuthStore().storeId || ''}`

export const readVoidPrintKitchen = (): boolean => {
  if (typeof window === 'undefined') return true
  try { return window.localStorage.getItem(KITCHEN_KEY) !== 'false' } catch { return true }
}

export const writeVoidPrintKitchen = (v: boolean) => {
  if (typeof window === 'undefined') return
  try { window.localStorage.setItem(KITCHEN_KEY, String(!!v)) } catch {}
}

export const readVoidCopyToCashier = (): boolean => {
  if (typeof window === 'undefined') return false
  try { return window.localStorage.getItem(cashierKey()) === 'true' } catch { return false }
}

export const writeVoidCopyToCashier = (v: boolean) => {
  if (typeof window === 'undefined') return
  try { window.localStorage.setItem(cashierKey(), String(!!v)) } catch {}
}
